export const USTimezonesByState = {
  AK: { tz: 'America/Anchorage', abbr: 'AKST' },
  HI: { tz: 'Pacific/Honolulu', abbr: 'HST' },
  CA: { tz: 'America/Los_Angeles', abbr: 'PST' },
  OR: { tz: 'America/Los_Angeles', abbr: 'PST' },
  WA: { tz: 'America/Los_Angeles', abbr: 'PST' },
  NV: { tz: 'America/Los_Angeles', abbr: 'PST' },
  AZ: { tz: 'America/Phoenix', abbr: 'MST' },
  CO: { tz: 'America/Denver', abbr: 'MST' },
  UT: { tz: 'America/Denver', abbr: 'MST' },
  MT: { tz: 'America/Denver', abbr: 'MST' },
  NM: { tz: 'America/Denver', abbr: 'MST' },
  ID: { tz: 'America/Denver', abbr: 'MST' },
  WY: { tz: 'America/Denver', abbr: 'MST' },
  ND: { tz: 'America/Chicago', abbr: 'CST' },
  TX: { tz: 'America/Chicago', abbr: 'CST' },
  MN: { tz: 'America/Chicago', abbr: 'CST' },
  MO: { tz: 'America/Chicago', abbr: 'CST' },
  OK: { tz: 'America/Chicago', abbr: 'CST' },
  IA: { tz: 'America/Chicago', abbr: 'CST' },
  KS: { tz: 'America/Chicago', abbr: 'CST' },
  LA: { tz: 'America/Chicago', abbr: 'CST' },
  MS: { tz: 'America/Chicago', abbr: 'CST' },
  SD: { tz: 'America/Chicago', abbr: 'CST' },
  AL: { tz: 'America/Chicago', abbr: 'CST' },
  AR: { tz: 'America/Chicago', abbr: 'CST' },
  NE: { tz: 'America/Chicago', abbr: 'CST' },
  NH: { tz: 'America/New_York', abbr: 'EST' },
  VT: { tz: 'America/New_York', abbr: 'EST' },
  WV: { tz: 'America/New_York', abbr: 'EST' },
  CT: { tz: 'America/New_York', abbr: 'EST' },
  DE: { tz: 'America/New_York', abbr: 'EST' },
  DC: { tz: 'America/New_York', abbr: 'EST' },
  KY: { tz: 'America/New_York', abbr: 'EST' },
  MA: { tz: 'America/New_York', abbr: 'EST' },
  MD: { tz: 'America/New_York', abbr: 'EST' },
  NJ: { tz: 'America/New_York', abbr: 'EST' },
  NY: { tz: 'America/New_York', abbr: 'EST' },
  PA: { tz: 'America/New_York', abbr: 'EST' },
  NC: { tz: 'America/New_York', abbr: 'EST' },
  SC: { tz: 'America/New_York', abbr: 'EST' },
  RI: { tz: 'America/New_York', abbr: 'EST' },
  FL: { tz: 'America/New_York', abbr: 'EST' },
  IL: { tz: 'America/Chicago', abbr: 'CST' },
  MI: { tz: 'America/Detroit', abbr: 'EST' },
  IN: { tz: 'America/Indiana/Indianapolis', abbr: 'EST' },
  OH: { tz: 'America/New_York', abbr: 'EST' },
  ME: { tz: 'America/New_York', abbr: 'EST' },
  TN: { tz: 'America/Chicago', abbr: 'CST' },
  GA: { tz: 'America/New_York', abbr: 'EST' },
  VA: { tz: 'America/New_York', abbr: 'EST' },
}
